import { NEARBY_AREAS, SERVICES, SITE } from "@/lib/site";

/** `tall` er de ekte Google-tallene fra Ascendly naar ruten har hentet dem (se forsiden). */
export function localBusinessJsonLd(extra?: Record<string, unknown>, tall?: { rating: number | null; antall: number | null } | null) {
  return {
    "@context": "https://schema.org",
    "@type": "AutoWash",
    name: SITE.name,
    url: SITE.url,
    sameAs: [SITE.facebookUrl],
    telephone: "+47 " + SITE.phone.replace(/\s/g, ""),
    email: SITE.email,
    priceRange: "$$",
    "@id": SITE.url + "/#bedrift",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Nedre Eikervei 47",
      postalCode: "3045",
      addressLocality: "Drammen",
      addressRegion: "Buskerud",
      addressCountry: "NO",
    },
    // Samme tider som i bunnteksten og paa /faq.
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "09:00",
        closes: "20:00",
      },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "09:00", closes: "19:00" },
    ],
    areaServed: [SITE.city, ...NEARBY_AREAS].map((name) => ({ "@type": "City", name })),
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Tjenester",
      itemListElement: SERVICES.map((s) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: s.name, description: s.desc },
      })),
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: tall?.rating ?? SITE.rating,
      reviewCount: tall?.antall ?? SITE.reviewCount,
    },
    ...extra,
  };
}

export function serviceJsonLd(name: string, description: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    areaServed: { "@type": "City", name: "Drammen" },
    provider: { "@type": "AutoWash", name: SITE.name },
    description,
  };
}

export function faqJsonLd(items: readonly { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}